import React, { Component,  useState, useEffect  } from 'react';
import './EstruturaTO4.css';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import orquestra from '../../assets/videos/orquestra.mp4';
import interativo2Ativo1 from '../../assets/svgs/interativoAtivo 1.svg';        
import Dt2 from "../../assets/fundos/Dt2.jpg";
import controleremoto from '../../assets/svgs/Controle-01.svg';      
import $, { when } from "jquery";
import { debounce, throttle } from 'lodash';
import seta from '../../assets/svgs/more-white.svg';     

class EstruturaTO4 extends Component {
    componentDidMount() {

        if(window.matchMedia("(max-width: 600px)").matches){
    
        }
        else{
          if($( ".magazinenova" ).mousemove=true){
            $( ".magazinenova" ).mousemove(function( event ) {
    
              $("#TO4desapa").fadeIn();
        
              
            });
          }
          else{
            $("#TO4desapa").fadeOut();
    
          }
    
        }
    
    
    
        $("#TO4dimensao").click(function()
        
        {

          $(".sidebar-wrapper").removeClass("show-sidebar", 500);
          $(".menuuu").addClass("todonone");
          $(".ffechar").addClass("todonone", 500);

          $("#TO4video").prop('muted', false);
          $("#TO4dimensao").addClass("todonone");
          $("#TO4dimensao2").removeClass("todonone");
          $("#TO4desapa2").addClass("todonone");
          $("#TO4video").addClass("pulo");
      
    
        }
        );
        $("#TO4dimensao2").click(function()
        
        {
          $(".menuuu").removeClass("todonone");
          $("#TO4video").prop('muted', true);
          $("#TO4dimensao2").addClass("todonone");
          $("#TO4dimensao").removeClass("todonone");
          $("#TO4desapa2").removeClass("todonone");
          $("#TO4obra1").removeClass("pulo");
          $("#TO4obra1").removeClass("pulo");
          $("#TO4video").removeClass("pulo");
          $("#TO4local1").removeClass("pulo");
        }
        );
    
    
        $("#TO4magazinenova").click(function(){
          $("#TO4desapa").delay('slow').fadeIn();
            
        
    
          setTimeout(
            function() 
            {
    
              
              var desaparecendo = 'todonone';
 
              $("#TO4desapa").fadeOut();
            }, 30000);
    
        });
    
        (function () {
    
          $("#TO4botomenu").click(function () {
            $( this ).slideUp().fadeOut(10000);
            $("#TO4hold1 ").addClass("cc");
            $("#TO4botoobras ").addClass("cc");
            $("#TO4hold3 ").addClass("cc");
            $("#TO4hold4 ").addClass("cc");
            $("#TO4hold5 ").addClass("cc");
            $("#TO4hold1 ").removeClass("transiopaca");
            $("#TO4botoobras ").removeClass("transiopaca");
            $("#TO4hold3 ").removeClass("transiopaca");
            $("#TO4hold4 ").removeClass("transiopaca");
            $("#TO4hold5 ").removeClass("transiopaca");
            setTimeout(function(){
              setTimeout(function(){
                $("#TO4hold5 ").addClass("transiopaca");
                setTimeout(function(){
                  $("#TO4hold4 ").addClass("transiopaca");
                  setTimeout(function(){
                    $("#TO4hold3 ").addClass("transiopaca");
                    setTimeout(function(){
                      $("#TO4botoobras ").addClass("transiopaca");
                      $("#TO4hold1 ").addClass("transiopaca");
                      setTimeout(function(){
                        $("#TO4hold1 ").removeClass("cc");
                        $("#TO4botoobras ").removeClass("cc");
                        $("#TO4hold3 ").removeClass("cc");
                        $("#TO4hold4 ").removeClass("cc");
                        $("#TO4hold5 ").removeClass("cc");
                        $("#TO4botomenu").slideDown();
                      },1000);
                    },1000);
    
    
                  },1000);
    
    
                },1000);
    
              },1000);
    
    
    
    
    
    
    
              }, 3000);
 
          });
    
          var qua = $('.resposta');
          var $target = $('.gatilhoObra'),
            animationClass = 'respostaGatilho',
            animationClass2 = 'respostaGatilho2',
            offset = $(window).height() * 1 / 10;
    
    
    
          function animeScroll() {
            $("#TO4desapa").fadeOut();
            
        
    
            setTimeout(
              function() 
              {
                var desaparecendo = 'todonone';

                $("#TO4desapa").fadeIn();
              }, 2000);
    
    
            var documentTop = $(document).scrollTop();
    
            $target.each(function (index) {
    
              var itemTop = $(this).offset().top;
    
              if (documentTop > itemTop - offset) {
                $("#TO4botoobras").addClass(animationClass2);
                
              }
              else{
                $("#TO4boto" + index).removeClass(animationClass);
                  
              }
    
              if (documentTop > itemTop - offset) {
                $("#TO4boto" + index).addClass(animationClass);
                
                if (documentTop > itemTop * 2 - offset * 2) {
                  $("#TO4boto" + index).removeClass(animationClass);
                  
                }
                if (documentTop > itemTop){
                  $("#TO4boto" + index).removeClass(animationClass);
                  
                }
              }
            }
    
            
    
            );
          }
    
         
    
          $(document).scroll(debounce(function () {
            animeScroll();
          }, 200));
        })();
    
    
        $('.bolinhas a[href^="#TO4"]').on('click', function (e) {
          e.preventDefault();
          var id = $(this).attr('href'),
            targetOffset = $(id).offset().top;
    
          $('html, body').animate({
            scrollTop: targetOffset - 0
          }, 500);
        });
    
        $('.grandeMenu a[href^="#TO4"]').on('click', function (e) {
          e.preventDefault();
          var id = $(this).attr('href'),
            targetOffset = $(id).offset().top;
    
          $('html, body').animate({
            scrollTop: targetOffset - 0
          }, 500);
        });
      }
      
    render() {
        return (
            <div id="TO4obra1" className="displayTO4 gatilhoObra"> {this.props.children}
                <div id="TO4local1"className="videolocalTO4" style={{backgroundImage: 'url(' + {Dt2} +')'}}>                   
                <div class="sidebar-wrapper">
                        <div class="sidebar">
                            <h3>2018   </h3>
                            <h2 class="sidebar-titulo">ORCHESTRE D'OISEAUX  </h2>
                            <p class="descricao">L'œuvre expose un orchestre d'oiseaux de Goiás, au Brésil, rendu possible par le commandement aérien des interacteurs et audible à travers l'interface de la camionnette d'un mur à Goiás. Par conséquent, il hybride un système sonore de type structure de haute intensité avec la manifestation du chant des oiseaux des hauts plateaux du centre du Brésil. Parodiant et hybridant les vers des poètes brésiliens Manoel de Barros et Cora Coralina, nous essayons d'exprimer en mots un peu l'expérience transitive des sens dans l'œuvre: "la voix d'un oiseau me récite": et j'écoute le couleur des oiseaux ". Ainsi, l'œuvre permet à l'homme de chanter des oiseaux et de faire briller des sons, hybrides et fusionnant différentes expériences et ontologies où la synesthésie est invoquée, dans un bref moment fictif où d'autres manières d'être sont possibles.</p>
                            <a className="botaops psaa"  href="
https://orquestradepassaros.netlify.app/">TRAVAIL INTERACTIF</a>
                        </div>
                        <div class="menuuu" id="menuuu"><i class="fa fa-bars fa-2x">
                        <img className="ring button" src={seta} alt=""/>
                        
                            
                            
                            
                            
                            </i></div>
                    </div>

                    
                    <div className="tampavideoTO4">
                    </div>
                    <div className="ffechar todonone">
                       <i> FERMER </i>
                    </div>
                    <div className="videoTO4" >
                        <video controlsList = "nofullscreen nodownload noremoteplayback" poster="a" id="TO4video" playsInline autoPlay muted loop>
                            <source src={orquestra} type="video/mp4">
                            </source>
                        </video>
                    </div>
                    <div className="sobrepo1TO4"></div>
                    <div className="sobrepo2TO4"></div>
                    <div className="sobrepo3TO4"></div>
                </div>
                <div id="TO4desapa" className="magazineTO4">
              
                
                </div>
                <div className="magazinenova" id="TO4magazinenova">
                    <div id="TO4dimensao"className="controleremoto">
                        <img src={controleremoto} alt=""/>
                    </div>
                    <div id="TO4dimensao2"className="controleremoto2 todonone">
                    <img src={controleremoto} alt=""/>
                        
                </div>
                </div>
            </div>
        );
    }
}
 
export default EstruturaTO4  ;